import { createI18n } from 'vue-i18n'
// @ts-expect-error: element-plus does not provide types for its locale files
import elementEnLocale from 'element-plus/dist/locale/en'
// @ts-expect-error: element-plus does not provide types for its locale files
import elementDeLocale from 'element-plus/dist/locale/de'
// @ts-expect-error: element-plus does not provide types for its locale files
import elementFrLocale from 'element-plus/dist/locale/fr'
import csCZ from './locales/cs-CZ.json'
import deDEGastro from './locales/de-DE-gastro.json'
import deDE from './locales/de-DE.json'
import enUSGastro from './locales/en-US-gastro.json'
import enUS from './locales/en-US.json'
import esES from './locales/es-ES.json'
import frFR from './locales/fr-FR.json'
import huHU from './locales/hu-HU.json'
import itIT from './locales/it-IT.json'

type AvailableLocales = keyof typeof messages

const messages = {
  'cs-CZ': csCZ,
  'de-DE-gastro': deDEGastro,
  'en-US-gastro': enUSGastro,
  'de-DE': {
    ...deDE,
    ...elementDeLocale
  },
  'en-US': {
    ...enUS,
    ...elementEnLocale
  },
  'es-ES': esES,
  'fr-FR': {
    ...frFR,
    ...elementFrLocale
  },
  'hu-HU': huHU,
  'it-IT': itIT
} as const

const messageKeys = Object.keys(messages) as AvailableLocales[]
const initialLocale: string | undefined = window?.navigator?.language

let targetLocale: AvailableLocales | undefined

if (!initialLocale) {
  // no reported locale -> we do nothing, as this case is handled by `fallbackLocale`
} else if (messageKeys.includes(initialLocale)) {
  targetLocale = initialLocale as AvailableLocales
} else {
  // initial locale does not match any defined locale
  // could happen if browser language is e.g. 'de'
  // trying to find partial match, e.g. 'de' => 'de-DE'
  // first we get the base lang, so that 'de-AT' can fall back to 'de-DE' as well
  const baseLocale = initialLocale?.split('-')[0]

  if (baseLocale) {
    const partialMatches = messageKeys
      .sort()
      .filter((l: string) => l.startsWith(baseLocale))
    if (partialMatches.length) {
      targetLocale = partialMatches[0]
    }
  }
}

const fallbackLocale: AvailableLocales = 'en-US'

export default createI18n({
  locale: targetLocale || fallbackLocale,
  legacy: false, // you must set `false`, to use Composition API
  globalInjection: true,
  fallbackLocale: {
    'en-US-gastro': ['en-US'],
    'de-DE-gastro': ['de-DE'],
    'fr-FR': ['en-US'],
    default: [fallbackLocale]
  },
  missingWarn: false,
  fallbackWarn: false,
  messages
})
